import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

interface Props {
  amount: number
  thisCycle: string
}

const Accrued = ({ amount, thisCycle }: Props) => {
  return (
    <Box>
      <Box flexDirection="row" justifyContent="spaceBetween">
        <Text.Normal>{i18n.t('time_off.available_tooltip.accrued')}</Text.Normal>
        <Text.Normal>{i18n.formatNumber(amount)}</Text.Normal>
      </Box>
      <Box flexDirection="row" justifyContent="flexStart">
        <Text.Normal size="200">
          {i18n.t('time_off.tooltip_common.generated_on', {
            cycle: thisCycle,
          })}
        </Text.Normal>
      </Box>
    </Box>
  )
}

export default observer(Accrued)
